import format from '../plugins/baseFormat';

const mapType = new Map([
  ['TEMPORARY', 'Sazonal',],
  ['GLOBAL', 'Permanente',],
],);

const mapCampaignType = new Map([
  ['PRODUCT', 'Produto',],
  ['COMPANY', 'Loja',],
],);

export default class Campaign {
  constructor (initialData = {},) {
    const {
      id,
      name,
      description,
      rule,
      enabled,
      type,
      image_url,
      init_date,
      end_date,
      created_at,
      created_by,
      updated_at,
      updated_by,
      campaign_type,
      product_campaign,
      franchises,
      payment_methods,
    } = initialData;

    this.id = id;
    this.name = name;
    this.description = description;
    this.rule = rule;
    this.enabled = enabled;
    this.type = type;
    this.image_url = image_url;
    this.init_date = init_date;
    this.end_date = end_date;
    this.created_at = created_at;
    this.created_by = created_by;
    this.updated_at = updated_at;
    this.updated_by = updated_by;
    this.campaign_type = campaign_type;
    this.product_campaign = product_campaign;
    this.franchises = franchises;
    this.payment_methods = payment_methods;
  }

  set Campaign (campaign,) {
    this.id = campaign.id;
    this.name = campaign.name;
    this.enabled = campaign.enabled;
    this.type = mapType.get(campaign.type,);
    this.init_date = campaign.init_date.at;
    this.end_date = campaign.end_date.at;
    this.created_at = campaign.created_at.at;
    this.created_by = campaign.created_by;
    this.updated_at = campaign.updated_at.at;
    this.updated_by = campaign.updated_by;
    this.campaign_type = mapCampaignType.get(campaign.campaign_type,);
    this.franchises = franchises;
    this.payment_methods = payment_methods;
  }

  get toPost () {
    return {
      name: this.name,
      description: this.description,
      rule: this.rule,
      enabled: this.enabled,
      type: this.type,
      init_date: format.date(this.init_date,).format('YYYY-MM-DDTHH:mm:ssZ',),
      end_date: format.date(this.end_date,).format('YYYY-MM-DDTHH:mm:ssZ',),
      image_url: this.image_url,
      campaign_type: this.campaign_type,
      product_campaign: this.product_campaign,
      franchises: this.franchises,
      payment_methods: this.payment_methods,
    };
  }

  get formatted_created () {
    return format.date(this.created_at,).format('DD/MM/YYYY HH:mm',);
  }

  get formatted_init_date () {
    return this.init_date ? format.date(this.init_date,).format('DD/MM/YYYY HH:mm',) : 'Nunca';
  }

  get formatted_end_date () {
    return this.end_date ? format.date(this.end_date,).format('DD/MM/YYYY HH:mm',) : 'Nunca';
  }

  get formatted_type () {
    return mapType.get(this.type,);
  }

  get formatted_campaign_type () {
    return mapCampaignType.get(this.campaign_type,);
  }
}
